export const MentalHealthRaw = [
  { Mental_raw_score: 4, Mental_SummedScore: 21.2, Mental_T_Score: 4.6 },
  { Mental_raw_score: 5, Mental_SummedScore: 25.1, Mental_T_Score: 4.1 },
  { Mental_raw_score: 6, Mental_SummedScore: 28.4, Mental_T_Score: 3.9 },
  { Mental_raw_score: 7, Mental_SummedScore: 31.3, Mental_T_Score: 3.7 },
  { Mental_raw_score: 8, Mental_SummedScore: 33.8, Mental_T_Score: 3.7 },
  { Mental_raw_score: 9, Mental_SummedScore: 36.3, Mental_T_Score: 3.7 },
  { Mental_raw_score: 10, Mental_SummedScore: 38.8, Mental_T_Score: 3.6 },
  { Mental_raw_score: 11, Mental_SummedScore: 41.1, Mental_T_Score: 3.6 },
  { Mental_raw_score: 12, Mental_SummedScore: 43.5, Mental_T_Score: 3.6 },
  { Mental_raw_score: 13, Mental_SummedScore: 45.8, Mental_T_Score: 3.6 },
  { Mental_raw_score: 14, Mental_SummedScore: 48.3, Mental_T_Score: 3.7 },
  { Mental_raw_score: 15, Mental_SummedScore: 50.8, Mental_T_Score: 3.7 },
  { Mental_raw_score: 16, Mental_SummedScore: 53.3, Mental_T_Score: 3.7 },
  { Mental_raw_score: 17, Mental_SummedScore: 56.0, Mental_T_Score: 3.8 },
  { Mental_raw_score: 18, Mental_SummedScore: 59.0, Mental_T_Score: 3.9 },
  { Mental_raw_score: 19, Mental_SummedScore: 62.5, Mental_T_Score: 4.2 },
  { Mental_raw_score: 20, Mental_SummedScore: 67.6, Mental_T_Score: 5.3 },
];
